import React from 'react';
import {Link} from 'react-router-dom';
import './style.scss';
import {ArrowForwardRounded, CheckCircleOutlineRounded} from '@mui/icons-material';
import {Text, Title} from '../@Text';
import {isPRD} from '../../../utlis/vars';

interface IHomeLink {
  children: string;
  description: string;
  index: number;
  id?: string;
  to?: string;
  active?: boolean;
  completed?: boolean;
  onClick?: () => void;
  'data-testid'?: string;
  style?: React.CSSProperties;
  hrStyle?: React.CSSProperties;
}

const unicodeFrom = 9311;

const HomeLink = ({
                    children: text,
                    description,
                    id,
                    style,
                    hrStyle,
                    to = '',
                    index,
                    active = false,
                    completed = false,
                    'data-testid': dataTestId,
                    onClick
                  }: IHomeLink): React.ReactElement => {
  return (
    <div
      id={id}
      style={style}
      className={`fm-homelink${!active ? ' fm-homelink-inactive' : ''}`}
      data-testid={isPRD ? undefined : dataTestId}
    >
      {index <= 1 ? <hr style={hrStyle} className="fm-homelink-hr"/> : null}
      {completed ? (
        <div
          id={id}
          style={style}
          data-testid={isPRD ? undefined : dataTestId}
          className="fm-homelink-title-wrapper fm-homelink-completed"
        >
          <CheckCircleOutlineRounded className="fm-homelink-check"/>

          <Title color="green">{text}</Title>
        </div>
      ) : active ? (
        onClick ? (
          <div
            id={id}
            style={style}
            data-testid={isPRD ? undefined : dataTestId}
            onClick={onClick}
            className="fm-hl-div-link-active"
          >
            <div className="fm-homelink-title-wrapper fm-hl-wrapper-active">
              <div className="fm-homelink-index-title-wrapper">
                                <span className="fm-homelink-index fm-hl-active">
                                    {String.fromCodePoint(unicodeFrom + index)}
                                </span>

                <Title color="blue" className="fm-hl-active">
                  {text}
                </Title>
              </div>

              <ArrowForwardRounded className="fm-homelink-arrow fm-hl-active"/>
            </div>

            <Text color="black" style={{paddingLeft: 27}}>
              {description}
            </Text>
          </div>
        ) : (
          <Link to={to} id={id} data-testid={isPRD ? undefined : dataTestId} style={style}>
            <div className="fm-homelink-title-wrapper fm-hl-wrapper-active">
              <div className="fm-homelink-index-title-wrapper">
                                <span className="fm-homelink-index fm-hl-active">
                                    {String.fromCodePoint(unicodeFrom + index)}
                                </span>

                <Title color="blue" className="fm-hl-active">
                  {text}
                </Title>
              </div>

              <ArrowForwardRounded className="fm-homelink-arrow fm-hl-active"/>
            </div>

            <Text color="black" style={{paddingLeft: 27}}>
              {description}
            </Text>
          </Link>
        )
      ) : (
        <div
          id={id}
          style={style}
          data-testid={isPRD ? undefined : dataTestId}
          className="fm-homelink-title-wrapper"
        >
          <span className="fm-homelink-index">{String.fromCodePoint(unicodeFrom + index)}</span>

          <Title color="gray">{text}</Title>
        </div>
      )}
      <hr style={hrStyle} className="fm-homelink-hr"/>
    </div>
  );
};

export default HomeLink;
